module.exports = {"product":"DEDL Portal","description":"Explore the data portfolio and priority services of DestinE","author":"DEDL Team <TODO>"}